<template>
  <div class="c-list">
    <div v-for="(item, itemIndex) in items" :key="itemIndex" class="c-list-item">
      <div class="c-list-item-title">
        <div class="c-list-item-title-text" @click="onClickTitle(item)">{{ item.title }}</div>
        <div class="c-list-item-title-description">{{ item.description }}</div>
      </div>

      <div class="c-list-item-actions">
        <div
          v-for="(action, actionIndex) in item.actions"
          :key="actionIndex"
          class="c-list-item-action"
          :class="getItemActionStyles(action)"
          @click="onClickAction(item, action)"
        >
          <svg
            v-if="action.icon === 'trash'"
            class="c-list-item-action_trash"
            width="13"
            height="15"
            viewBox="0 0 13 15"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 3C0.447715 3 0 3.44772 0 4C0 4.55228 0.447715 5 1 5V3ZM12 5C12.5523 5 13 4.55228 13 4C13 3.44772 12.5523 3 12 3V5ZM2.92846 3.6C2.92846 4.15228 3.37618 4.6 3.92846 4.6C4.48075 4.6 4.92846 4.15228 4.92846 3.6H2.92846ZM5.21418 1V0V1ZM7.78561 1V0V1ZM8.07132 3.6C8.07132 4.15228 8.51903 4.6 9.07132 4.6C9.6236 4.6 10.0713 4.15228 10.0713 3.6H8.07132ZM6 7C6 6.44772 5.55228 6 5 6C4.44772 6 4 6.44772 4 7H6ZM4 11C4 11.5523 4.44772 12 5 12C5.55228 12 6 11.5523 6 11H4ZM9 7C9 6.44772 8.55228 6 8 6C7.44772 6 7 6.44772 7 7H9ZM7 11C7 11.5523 7.44772 12 8 12C8.55228 12 9 11.5523 9 11H7ZM1 5H12V3H1V5ZM4.92846 3.6V2.3H2.92846V3.6H4.92846ZM4.92846 2.3C4.92846 2.21689 4.96122 2.13938 5.01604 2.08395L3.59404 0.677572C3.16663 1.10973 2.92846 1.69355 2.92846 2.3H4.92846ZM5.01604 2.08395C5.0705 2.02889 5.14199 2 5.21418 2V0C4.60438 0 4.02182 0.245036 3.59404 0.677572L5.01604 2.08395ZM5.21418 2H7.78561V0H5.21418V2ZM7.78561 2C7.85779 2 7.92929 2.02889 7.98374 2.08395L9.40575 0.677572C8.97796 0.245036 8.3954 0 7.78561 0V2ZM7.98374 2.08395C8.03856 2.13938 8.07132 2.21689 8.07132 2.3H10.0713C10.0713 1.69355 9.83316 1.10973 9.40575 0.677572L7.98374 2.08395ZM8.07132 2.3V3.6H10.0713V2.3H8.07132ZM4 7V11H6V7H4ZM7 7V11H9V7H7ZM10 4V12H12V4H10ZM9 13H4V15H9V13ZM3 12V4H1V12H3ZM4 13C3.44772 13 3 12.5523 3 12H1C1 13.6569 2.34315 15 4 15V13ZM10 12C10 12.5523 9.55228 13 9 13V15C10.6569 15 12 13.6569 12 12H10Z"
            />
          </svg>

          <svg
            v-if="action.icon === 'share'"
            class="c-list-item-action_share"
            width="14"
            height="16"
            viewBox="0 0 14 16"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 3C12 3.55228 11.5523 4 11 4V6C12.6569 6 14 4.65685 14 3H12ZM11 4C10.4477 4 10 3.55228 10 3H8C8 4.65685 9.34315 6 11 6V4ZM10 3C10 2.44772 10.4477 2 11 2V0C9.34315 0 8 1.34315 8 3H10ZM11 2C11.5523 2 12 2.44772 12 3H14C14 1.34315 12.6569 0 11 0V2ZM14 13C14 11.3431 12.6569 10 11 10V12C11.5523 12 12 12.4477 12 13H14ZM11 10C9.34315 10 8 11.3431 8 13H10C10 12.4477 10.4477 12 11 12V10ZM8 13C8 14.6569 9.34315 16 11 16V14C10.4477 14 10 13.5523 10 13H8ZM11 16C12.6569 16 14 14.6569 14 13H12C12 13.5523 11.5523 14 11 14V16ZM4 8C4 8.55228 3.55228 9 3 9V11C4.65685 11 6 9.65685 6 8H4ZM3 9C2.44772 9 2 8.55228 2 8H0C0 9.65685 1.34315 11 3 11V9ZM2 8C2 7.44772 2.44772 7 3 7V5C1.34315 5 0 6.34315 0 8H2ZM3 7C3.55228 7 4 7.44772 4 8H6C6 6.34315 4.65685 5 3 5V7ZM8.94036 3.1237L4.251 6.10283L5.32346 7.79097L10.0128 4.81184L8.94036 3.1237ZM10.0128 11.2287L5.32346 8.24956L4.251 9.9377L8.94036 12.9168L10.0128 11.2287Z"
            />
          </svg>

          <div class="c-list-item-action-tooltip">{{ action.label }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "c-list",

  props: ["items"],

  methods: {
    getItemActionStyles(action) {
      return {
        "c-list-item-action_secondary": action.color === "secondary",
      };
    },

    onClickAction(item, action) {
      const data = {
        id: item.id,
        action: action.action,
        title: item.title,
      };

      this.$emit("clickAction", data);
    },

    onClickTitle(item) {
      this.$emit("clickTitle", item);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.c-list {
  display: flex;
  flex-direction: column;
  width: calc(100% + 10px);
  max-height: calc(65px * 5);
  overflow-y: auto;
  padding-right: 10px;
  margin-right: -10px;

  &::-webkit-scrollbar {
    width: 4px;
    height: 100%;
    background: white;
    cursor: pointer;
  }

  &::-webkit-scrollbar-thumb {
    background: $color-secondary;
    border-radius: 2px;
  }

  &::-webkit-scrollbar-track {
    background: $color-border-alt;
    width: 4px;
    border-radius: 2px;
  }

  &-item {
    width: 100%;
    display: flex;
    padding: 10px;
    border-top: 1px solid $color-border-alt;
    justify-content: space-between;
    align-items: center;

    &:last-child {
      border-bottom: 1px solid $color-border-alt;
    }

    &-title {
      margin-right: 20px;

      &-text {
        color: $color-primary;
        font: {
          size: 13px;
          weight: 500;
        }
        cursor: pointer;
      }

      &-description {
        font-size: 13px;
        color: $color-label;
        margin-top: 5px;
      }
    }

    &-actions {
      display: flex;
    }

    &-action {
      margin-right: 20px;
      cursor: pointer;
      position: relative;
      z-index: 20;

      &:last-child {
        margin-right: 0;
      }

      svg {
        fill: $color-label;
        position: relative;
        z-index: 20;
      }

      &_secondary {
        svg {
          fill: $color-secondary;
        }
      }

      &-tooltip {
        position: absolute;
        background: white;
        top: -40px;
        padding: 0.75rem 1rem;
        border-radius: 6px;
        box-shadow: 0px 4px 16px rgba(0, 15, 38, 0.25);
        font-size: 13px;
        left: -50px;
        z-index: 30;
        width: 120px;
        text-align: center;
        opacity: 0;
        visibility: hidden;
        transition: 0.2s;
        pointer-events: none;
      }

      &:hover {
        .c-list-item-action-tooltip {
          opacity: 1;
          visibility: visible;
          top: -45px;
        }
      }
    }
  }
}
</style>
